// Bundle Cascade — suppression automatique du liner quand le casque est supprimé

(function() {

  function initCascade() {
    var removeLinks = document.querySelectorAll('[data-remove-line-key]');
    removeLinks.forEach(function(link) {
      if (link.dataset.cascadeInit) return;
      link.dataset.cascadeInit = 'true';

      var lineKey = link.getAttribute('data-remove-line-key');
      link.removeAttribute('href');
      link.style.cursor = 'pointer';

      link.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var cartData = await fetch('/cart.js').then(function(r) { return r.json(); });
        var liners = cartData.items.filter(function(i) {
          return i.properties && i.properties['_bundle_liner'] === 'true';
        });

        // Supprimer le casque EN PREMIER
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        });

        // Puis supprimer le liner
        if (liners.length > 0) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: liners[0].key, quantity: 0 })
          });
        }

        if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
          window.location.reload();
        } else {
          var updatedCart = await fetch('/cart.js').then(function(r) { return r.json(); });
          var sectionsToBundle = new Set();
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true, detail: { sections: sectionsToBundle }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'line-item:change', cart: updatedCart }
          }));
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initCascade);
  document.addEventListener('cart:refresh', function() { setTimeout(initCascade, 300); });
  document.documentElement.addEventListener('cart:change', function() { setTimeout(initCascade, 300); });

})();
